import { render } from "./DatasetUpdateModal.vue?vue&type=template&id=48ac8acb&scoped=true"
import script from "./DatasetUpdateModal.vue?vue&type=script&lang=js"
export * from "./DatasetUpdateModal.vue?vue&type=script&lang=js"

import "./DatasetUpdateModal.vue?vue&type=style&index=0&id=48ac8acb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ac8acb"]])

export default __exports__